// @flow
import React from 'react';
import GetStartedEdit from './GetStartedEdit';

const GetStartedList = () => <GetStartedEdit />;

export default GetStartedList;
